// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM8 9.5V8.5H6V9.5C6 10.8807 7.11929 12 8.5 12C9.88071 12 11 10.8807 11 9.5V8.5H9V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5ZM15 9.5V8.5H13V9.5C13 10.8807 14.1193 12 15.5 12C16.8807 12 18 10.8807 18 9.5V8.5H16V9.5C16 9.77614 15.7761 10 15.5 10C15.2239 10 15 9.77614 15 9.5ZM13.0039 14H11V16.0039H13.0039V14Z"}}]};

const SleepFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sleep-filled',
    ref,
    icon: element,
  },
));

SleepFilledIcon.displayName = 'SleepFilledIcon';

export default SleepFilledIcon;
